import { t } from "ttag";

import { AdminSettingsLayout } from "metabase/admin/components/AdminLayout/AdminSettingsLayout";
import {
  AdminNavItem,
  AdminNavWrapper,
} from "metabase/admin/components/AdminNav";
import { usePageTitle } from "metabase/hooks/use-page-title";
import { PLUGIN_CACHING, PerformanceTabId } from "metabase/plugins";

import { getPerformanceTabName } from "../utils";

export const PerformanceApp = ({ children }: { children: React.ReactNode }) => {
  // A fractional index (between "Admin" at 0.25 and this section's own leaf
  // pages at 1): a tie with a nested leaf's title would resolve by mount
  // order, not visual nesting, making the final order nondeterministic.
  usePageTitle(t`Performance`, { titleIndex: 0.5 });

  return (
    <AdminSettingsLayout
      maw="60rem"
      sidebar={
        <AdminNavWrapper>
          <AdminNavItem
            label={getPerformanceTabName(PerformanceTabId.Databases)}
            path="/admin/performance/databases"
            icon="database"
          />
          {PLUGIN_CACHING.isGranularCachingEnabled() && (
            <AdminNavItem
              label={getPerformanceTabName(
                PerformanceTabId.DashboardsAndQuestions,
              )}
              path="/admin/performance/dashboards-and-questions"
              icon="dashboard"
            />
          )}
          <AdminNavItem
            label={getPerformanceTabName(PerformanceTabId.Models)}
            path="/admin/performance/models"
            icon="model"
          />
        </AdminNavWrapper>
      }
    >
      {children}
    </AdminSettingsLayout>
  );
};
